import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./DeskTopTrackOrder.module.css";
import { useContext, useEffect, useRef, useState } from "react";
import { storeRequester } from "App";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";

import clsx from "classnames";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import TestDatePicker from "components/inputs/datePicker/TestDatePicker";
import DateChoice from "components/inputs/datePicker/dateChoice/DateChoice";
import { useLocation } from "react-router-dom";
import { AuthContext } from "providers/AuthProvider";

import { addCommas } from "shared/utils/Utils";
import CustomPagination from "components/pagination/CustomPagination";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Center from "layouts/wrapper/Center";
import OrderList from "../OrderList";
import MypageContentHeader from "../../header/MypageContentHeader";

function DeskTopTrackOrder() {
  const [isOrderList, setOrderList] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName } = useContext(AuthContext);
  const { state } = useLocation();
  const dateRef = useRef();
  const { isLoading } = useSelector((state) => ({
    isLoading: state.history.isLoading,
  }));
  const [orderInfo, setOrderInfo] = useState({
    preparing: 0, // 상품 준비
    awaitingShipping: 0, // 배송 대기
    inShipping: 0, // 배송 중
    completed: 0, // 배송 완료
    other: 0, // 교환, 환불, 취소
  });
  const [selectedStatus, setSelectedStatus] = useState("all"); // 선택된 상태

  useEffect(() => {
    const end = new Date(); // 오늘 날짜
    const start = new Date(); // 오늘 날짜 복사
    start.setMonth(start.getMonth() - 1); // 1달 전으로 설정
    onLookUpClick(start, end);
    dispatch(HistoryReducer.actions.setLoading(true));
  }, [])
  const onLookUpClick = (start, end) => {
    
    dispatch(HistoryReducer.actions.setLoading(true));
    fetchOrders(200, 0, start, end);
    setCurrentPage(1)

  };
  const fetchOrders = async (limit, offset, start, end) => {
    try {

      const { orders } = await storeRequester.getCustomerOrders({
        expand: "shipping_address",
        start_date: start,
        end_date: end,
        limit: limit,
        offset: offset,
      });
      if (orders) {
        dispatch(HistoryReducer.actions.setLoading(false));
        setOrderList(orders);
      }
    } catch (error) {
      
    }
  };

  const OrderInfo = (props) => {
    return (
      <VerticalFlex>
        <FlexChild>
          <P
            weight={"bold"}
            color={props.color ? props.color : "#999"}
            size={isMobile ? "24pt" : "24pt"}
            cursor="pointer"
            onClick={props.onClick} // 클릭 이벤트 추가
          >
            {props.value}
          </P>
        </FlexChild>
        <FlexChild>
          <P weight={"bold"} size={isMobile ? "11pt" : ""}>
            {props.text}
          </P>
        </FlexChild>
      </VerticalFlex>
    );
  };
  const formatDate = (dateString) => {
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dayOfWeek = days[date.getDay()];

    return `${year}.${month}.${day}(${dayOfWeek})`;
  };


  // ====== paging ======
  const itemsPerPage = 5; // 한 페이지에 보여줄 아이템 개수
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  useEffect(() => {
    if (isOrderList && isOrderList.length > 0) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setCurrentData(isOrderList.slice(startIndex, endIndex));
    }

    if (isOrderList && Array.isArray(isOrderList)) {
      const statusCounts = {
        preparing: 0,
        awaitingShipping: 0,
        inShipping: 0,
        completed: 0,
        other: 0,
      };

      // 누락된 데이터를 저장할 배열
      const unhandledOrders = [];

      isOrderList.forEach(order => {
        const { status, payment_status, fulfillment_status } = order;
        let isHandled = false; // 이 주문이 처리되었는지 여부

        // 상품 준비, 배송 대기, 배송 중, 배송 완료 상태 처리
        if (
          status === "pending" &&
          ["awaiting", "captured"].includes(payment_status)
        ) {
          if (fulfillment_status === "not_fulfilled") {
            statusCounts.preparing++;
            isHandled = true;
          } else if (fulfillment_status === "fulfilled") {
            statusCounts.awaitingShipping++;
            isHandled = true;
          } else if (fulfillment_status === "partially_shipped") {
            statusCounts.inShipping++;
            isHandled = true;
          }
        } else if (
          status === "completed" &&
          ["awaiting", "captured"].includes(payment_status) &&
          fulfillment_status === "shipped"
        ) {
          statusCounts.completed++;
          isHandled = true;
        }

        // 교환, 환불, 취소 상태 처리
        if (
          (status === "canceled" &&
            ["awaiting", "captured", "canceled"].includes(payment_status) &&
            fulfillment_status === "canceled") ||
          (status === "exchange" &&
            ["awaiting", "captured"].includes(payment_status)) ||
          (status === "refund" && ["awaiting", "refunded"].includes(payment_status))
        ) {
          statusCounts.other++;
          isHandled = true;
        }

        // 처리되지 않은 데이터 저장
        if (!isHandled) {
          unhandledOrders.push(order);
        }
      });

      // 상태 업데이트
      setOrderInfo(statusCounts);

    }
  }, [currentPage, isOrderList]);

  useEffect(() => {
    if (isOrderList) {
      const filteredList =
        selectedStatus === "all"
          ? isOrderList // "all"이면 전체 데이터를 표시
          : isOrderList.filter((order) => {
            const { status, payment_status, fulfillment_status } = order;

            // 상태별 필터링 로직
            if (
              selectedStatus === "preparing" &&
              status === "pending" &&
              fulfillment_status === "not_fulfilled"
            ) {
              return true;
            }
            if (
              selectedStatus === "awaitingShipping" &&
              status === "pending" &&
              fulfillment_status === "fulfilled"
            ) {
              return true;
            }
            if (
              selectedStatus === "inShipping" &&
              status === "pending" &&
              fulfillment_status === "partially_shipped"
            ) {
              return true;
            }
            if (
              selectedStatus === "completed" &&
              status === "completed" &&
              fulfillment_status === "shipped"
            ) {
              return true;
            }
            if (
              selectedStatus === "other" &&
              ["canceled", "exchange", "refund"].includes(status)
            ) {
              return true;
            }
            return false;
          });

      // 페이징 처리
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setCurrentData(filteredList.slice(startIndex, endIndex));
    }
  }, [selectedStatus, currentPage, isOrderList]);

  // ====== paging ======

  const handleStatusClick = (statusKey) => {
    if (selectedStatus === statusKey) {
      return; // 현재 선택된 상태와 동일하면 아무 변화 없음
    }
    setSelectedStatus(statusKey); // 새로운 상태 설정
    setCurrentPage(1); // 페이지를 1로 리셋
  };

  return (
    <Container backgroundColor={"white"} minWidth={!isMobile && 1000}>
      <VerticalFlex gap={10}>
        <FlexChild>
          <VerticalFlex>
            <FlexChild>{isMobile && <MypageContentHeader />}</FlexChild>
            <FlexChild>
              <div className={style.deliveryWrap}>
                <HorizontalFlex
                  padding={isMobile ? "5px" : "30px"}
                  justifyContent={"space-around"}
                >
                  <FlexChild justifyContent={"center"} width={"initial"}>
                    <OrderInfo
                      color={
                        selectedStatus === "all"
                          ? "var(--main-color)" // 선택된 상태일 경우 강조 색상
                          : ""
                      }
                      value={
                        userName
                          ? isOrderList && isOrderList.length > 0
                            ? isOrderList.length // 전체 데이터 수 표시
                            : "0"
                          : "-"
                      }
                      text={t("all")} // "전체" 등 적절한 텍스트 번역
                      onClick={() => handleStatusClick("all")} // 클릭 시 "all" 상태 처리
                    />
                  </FlexChild>
                  <FlexChild justifyContent={"center"} width={"initial"}>
                    <OrderInfo
                      color={
                        selectedStatus === "preparing"
                          ? "var(--main-color)" // 선택된 상태일 경우 강조 색상
                          : ""
                      }
                      value={
                        userName
                          ? orderInfo
                            ? orderInfo.preparing
                            : "0"
                          : "-"
                      }
                      text={t("pending")}
                      onClick={() => handleStatusClick("preparing")}
                    />
                  </FlexChild>
                  <FlexChild justifyContent={"center"} width={"initial"}>
                    <OrderInfo
                      color={
                        selectedStatus === "awaitingShipping"
                          ? "var(--main-color)" // 선택된 상태일 경우 강조 색상
                          : ""
                      }
                      value={
                        userName
                          ? orderInfo
                            ? orderInfo.awaitingShipping
                            : "0"
                          : "-"
                      }
                      text={t("readyToShip")}
                      onClick={() => handleStatusClick("awaitingShipping")} // 클릭 시 "awaitingShipping" 상태 설정
                    />
                  </FlexChild>
                  <FlexChild justifyContent={"center"} width={"initial"}>
                    <OrderInfo
                      color={
                        selectedStatus === "inShipping"
                          ? "var(--main-color)" // 선택된 상태일 경우 강조 색상
                          : ""
                      }
                      value={
                        userName
                          ? orderInfo
                            ? orderInfo.inShipping
                            : "0"
                          : "-"
                      }
                      text={t("shipping")}
                      onClick={() => handleStatusClick("inShipping")}
                    />
                  </FlexChild>
                  <FlexChild justifyContent={"center"} width={"initial"}>
                    <OrderInfo
                      color={
                        selectedStatus === "completed"
                          ? "var(--main-color)" // 선택된 상태일 경우 강조 색상
                          : ""
                      }
                      value={
                        userName
                          ? orderInfo
                            ? orderInfo.completed
                            : "0"
                          : "-"
                      }
                      text={t("deliveryComplete")}
                      onClick={() => handleStatusClick("completed")}
                    />
                  </FlexChild>
                  <FlexChild justifyContent={"center"} width={"initial"}>
                    <OrderInfo
                      color={
                        selectedStatus === "other"
                          ? "var(--main-color)" // 선택된 상태일 경우 강조 색상
                          : ""
                      }
                      value={
                        userName
                          ? orderInfo
                            ? orderInfo.other
                            : "0"
                          : "-"
                      }
                      text={t("cancel/dispute")}
                      onClick={() => handleStatusClick("other")}
                    />
                  </FlexChild>
                </HorizontalFlex>
              </div>
            </FlexChild>
          </VerticalFlex>
        </FlexChild>
        <FlexChild>
          <DateChoice lookUp={onLookUpClick} value={state} ref={dateRef} />
        </FlexChild>
        <FlexChild>
          {isMobile ? (
            <VerticalFlex gap={15}>
              {currentData &&
                currentData.map((data, index) => {
                  
                  const onPurchaseOrderClick = () => {
                    NiceModal.show("purchaseOrder", { data: data });
                  };
                  return (
                    <FlexChild padding={"0px 10px"}>
                      <div className={style.horizontalCardWrap}>
                        <VerticalFlex gap={5}>
                          <FlexChild alignItems={"flex-start"}>
                            <P weight={"bold"} color={"#999"}>
                              {formatDate(data.created_at)}
                            </P>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex gap={15}>
                              <FlexChild width={"max-content"}>
                                <img
                                  width={"90px"}
                                  src={data.items[0].thumbnail}
                                />
                              </FlexChild>
                              <FlexChild>
                                <VerticalFlex flexStart gap={5}>
                                  <FlexChild>
                                    <HorizontalFlex>
                                      <FlexChild>
                                        <P
                                          weight={"bold"}
                                          color={"var(--main-color)"}
                                        >
                                          {t(data.status)}
                                        </P>
                                      </FlexChild>
                                    </HorizontalFlex>
                                  </FlexChild>
                                  <FlexChild>
                                    <P>{data.items[0].title}</P>
                                  </FlexChild>
                                  <FlexChild>
                                    <HorizontalFlex>
                                      <FlexChild>
                                        <P>
                                          {data.items[0].description}{" "}
                                          {t("other")} {data.items.length - 1}{" "}
                                          {t("cases")}
                                        </P>
                                      </FlexChild>
                                    </HorizontalFlex>
                                  </FlexChild>
                                  <FlexChild
                                    alignItems={"flex-end"}
                                    justifyContent={"flex-end"}
                                  >
                                    <P
                                      weight={"bold"}
                                      color={"var(--main-color)"}
                                    >
                                      &#8361;{addCommas(data.total)}
                                    </P>
                                  </FlexChild>
                                </VerticalFlex>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <P
                              cursor
                              onClick={onPurchaseOrderClick}
                              weight={"bold"}
                              color={"#999"}
                            >
                              상세보기
                            </P>
                          </FlexChild>
                        </VerticalFlex>
                      </div>
                    </FlexChild>
                  );
                })}
              <CustomPagination
                currentPage={currentPage}
                totalPages={
                  isOrderList &&
                  isOrderList.length > 0 &&
                  Math.ceil(isOrderList.length / itemsPerPage)
                }
                onPageChange={(page) => setCurrentPage(page)}
              />
            </VerticalFlex>
          ) : (
            <VerticalFlex padding={"0 0 20px 0"}>
              <FlexChild>
                <div className={style.tableHeaderWrap}>
                  <HorizontalFlex>
                    <FlexChild
                      width={isMobile ? "100px" : "150px"}
                      justifyContent={"center"}
                    >
                      <P>{t("orderTime")}</P>
                    </FlexChild>
                    <FlexChild justifyContent={"center"}>
                      <P>{t("product")}</P>
                    </FlexChild>
                    <FlexChild justifyContent={"center"}>
                      <P>{t("address")}</P>
                    </FlexChild>
                    <FlexChild width={"100px"} justifyContent={"center"}>
                      <P>{t("price")}</P>
                    </FlexChild>
                    <FlexChild width={"100px"} justifyContent={"center"}>
                      <P>{t("etc")}</P>
                    </FlexChild>
                  </HorizontalFlex>
                </div>
              </FlexChild>
              <FlexChild>
                {
                  isLoading
                    ?
                    <Center padding={"10px"}>
                      <P>데이터를 불러오고 있습니다</P>
                    </Center>
                    :
                    currentData &&
                      currentData.length > 0 ?
                      currentData.map((data, index) => (
                        <OrderList data={data} key={index} index={index} isLoading={isLoading} />
                      ))
                      :
                      <Center padding={"10px"}>
                        <P>상품이 없습니다</P>
                      </Center>
                }
              </FlexChild>
              <CustomPagination
                currentPage={currentPage}
                totalPages={
                  isOrderList
                    ? selectedStatus === "all"
                      ? Math.ceil(isOrderList.length / itemsPerPage) // 전체 데이터 수 기준
                      : Math.ceil(
                        isOrderList.filter((order) => {
                          const { status, payment_status, fulfillment_status } = order;

                          // 상태별 필터링 로직
                          if (
                            selectedStatus === "preparing" &&
                            status === "pending" &&
                            fulfillment_status === "not_fulfilled"
                          ) {
                            return true;
                          }
                          if (
                            selectedStatus === "awaitingShipping" &&
                            status === "pending" &&
                            fulfillment_status === "fulfilled"
                          ) {
                            return true;
                          }
                          if (
                            selectedStatus === "inShipping" &&
                            status === "pending" &&
                            fulfillment_status === "partially_shipped"
                          ) {
                            return true;
                          }
                          if (
                            selectedStatus === "completed" &&
                            status === "completed" &&
                            fulfillment_status === "shipped"
                          ) {
                            return true;
                          }
                          if (
                            selectedStatus === "other" &&
                            ["canceled", "exchange", "refund"].includes(status)
                          ) {
                            return true;
                          }
                          return false;
                        }).length / itemsPerPage
                      )
                    : Math.ceil(isOrderList && isOrderList.length / itemsPerPage)
                }
                onPageChange={(page) => setCurrentPage(page)}
              />

            </VerticalFlex>
          )}
        </FlexChild>
      </VerticalFlex>
    </Container>
  );
}

export default DeskTopTrackOrder;
